import { render, staticRenderFns } from "./MeasurementsEditDialog.vue?vue&type=template&id=70a13cd5&"
import script from "./MeasurementsEditDialog.vue?vue&type=script&lang=ts&"
export * from "./MeasurementsEditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
